import { getChecklistProgress } from 'ui/components/checklist/ChecklistForm/helpers'
import Checkbox from 'ui/components/forms/Checkbox'
import {
  ChecklistWrap,
  ChecklistTitle,
  ChecklistProgress,
  ChecklistProgressBar,
  ProgressCounter,
  ChecklistItems,
  ChecklistItemWrap,
  CheckboxWrap,
  CheclistItemText,
  CheclistPoint,
  CheclistText,
} from './styled'

const Checklist = ({
  className,
  checklist = {},
  variant = 'default',
  onTogglePoint,
}) => {
  const { name, points } = checklist
  const { isDone, total, percent } = getChecklistProgress(points)

  return (
    <ChecklistWrap className={className} $variant={variant}>
      <ChecklistTitle>{name}</ChecklistTitle>
      <ChecklistProgress>
        <ChecklistProgressBar percent={percent} />
        <ProgressCounter>
          {isDone}/{total}
        </ProgressCounter>
      </ChecklistProgress>
      <ChecklistItems>
        {points?.length > 0 &&
          points.map((point, i) => (
            <ChecklistItemWrap key={point.id} isDone={point.is_done}>
              <CheckboxWrap>
                <Checkbox
                  checked={point.is_done}
                  disabled={!onTogglePoint}
                  onChange={() => onTogglePoint?.(point)}
                />
              </CheckboxWrap>
              <CheclistItemText isDone={point.is_done}>
                <CheclistPoint>{++i}. </CheclistPoint>
                <CheclistText isDone={point.is_done}>{point.text}</CheclistText>
              </CheclistItemText>
            </ChecklistItemWrap>
          ))}
      </ChecklistItems>
    </ChecklistWrap>
  )
}

export default Checklist
